import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Game } from '../classes/Game';
import { AuthService } from '../services/auth.service';
import { GameService } from '../services/game.service';
import { TeamService } from '../services/team.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-spectator-team-list',
  templateUrl: './spectator-team-list.component.html',
  styleUrls: ['./spectator-team-list.component.scss']
})
export class SpectatorTeamListComponent implements OnInit {

  @Input() game: Game;
  @Input() startAutoJoin: string;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() startAuth: EventEmitter<string> = new EventEmitter();

  targetGame: any;
  isLoggedIn: boolean = false;
  my_client_id: string = '';
  default_team_avatar: string = 'https://kingtrivia.com/wp-content/plugins/king-trivia/images/kt-team-icon.jpg'
  addingTeam: boolean;
  teamRecords: TeamStub[] = [];
  fetchingTeams: boolean = true;
  loadingRequest: boolean = false;
  guest;
  contextAction: string;
  gameTeamCache: Team[] = [];

  err: string = "";

  constructor(
    private auth: AuthService,
    private gameService: GameService,
    private teamService: TeamService,
    private route: ActivatedRoute, 
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.auth.getToken() !== null;
    this.my_client_id = localStorage.getItem('kt_client_id');
    this.getTeamRecords();
    this.autoJoin();
    this.route.queryParams.subscribe(params => {
      if (params['guest']) {
        this.guest = params['guest'];
        this.addingTeam = true;
      }
      if (params['context']) {
        this.contextAction = params['context'];
        console.log(this.contextAction);
      }
      this.router.navigate(["."], { relativeTo: this.route })
    });
  }

  hide() {
		this.close.emit()
    sessionStorage.setItem('choseSpectator', 'true');
	}

  startAddTeam() {
    if (!this.isLoggedIn && !this.guest) this.toAuth();
    else this.addingTeam = true;
  }

  getGameTeams() {
    let rts = this.game.game_teams.filter((t) => t.kt_team_id && t.kt_team_id !== "0");
    if (this.teamRecords.length) {
      rts = rts.map((rt) => {
        let found = this.teamRecords.filter((tr) => tr.kt_team_id === rt.kt_team_id);
        if (found.length) rt.in_game = true;
        return rt;
      })
      rts.sort((a, b) => {
        if (a.in_game) return -1;
        else if (b.in_game) return 1;
        else return 0;
      })
    }
    this.gameTeamCache = rts;
    return rts;
  }

  leaveGame() {
    if (this.loadingRequest === true) return;
    this.loadingRequest = true;
    this.err = ""
    this.gameService.leaveGame(this.game.gameid)
      .subscribe(
        res => window.location.href = "/",
        err => {
          this.err = err.error.detail;
          this.loadingRequest = false;
        })
  }

  isInvited(team_code: string) {
    let invites = this.game.invites.filter((i) => i.team_code == team_code);
    return invites.length ? true : false;
  }

  autoJoin() {
    if (this.startAutoJoin) {
      let targetTeam = this.getGameTeams().filter((t) => t.team_code === this.startAutoJoin)
      if (targetTeam.length) {
        this.askToJoin(targetTeam[0]);
        this.startAutoJoin = "";
      }
    }
  }

  getTeamRecords() {
    this.teamService.getTeamList(true)
      .pipe(finalize(() => this.fetchingTeams = false))
      .subscribe((teams: TeamStub[]) => {
        this.teamRecords = teams;
      })
  }

  askToJoin(team: Team){
    if (!this.isLoggedIn) this.toAuth(`join${team.team_code}`);
    this.err = "";
    this.loadingRequest = true;
    this.game.me.status = "pending-join";
    this.game.my_team = team;
    this.gameService.joinTeam(team.team_code, this.game.gameid, this.my_client_id)
      .pipe(finalize(() => this.loadingRequest = false))
      .subscribe(
        (request: {success: boolean}) => {}, 
        error => {
          console.log("Error joining Team", error);
          this.game.me.status = "watching";
          this.game.my_team = null;
          this.err = "Something went wrong... Please try again"
      });
  }

  prefabTeam() {
    if (this.isLoggedIn) return null;
    else return {team_name: "", kt_team_id: "new", members: [], team_image: ""};
  }

  cancelJoinRequest(){
    this.err = "";
    if(this.game.my_team.team_code){
      this.loadingRequest = true;
      this.gameService.cancelJoinRequest(this.game.my_team.team_code, this.game.gameid, this.my_client_id)
        .pipe(finalize(() => this.loadingRequest = false))
        .subscribe((response) => {
          this.game.my_team = null;
          this.game.me.status = "watching";
        }, error => {
          console.log("Failed to cancel request", error);
          this.err = "Something went wrong... Please try again"
        });
    }
    else {
      this.game.me.status = "watching";
      this.game.my_team = undefined;
      } 
  }

  joinedToTeam(team: Team){
    return this.game.my_team?.team_code === team.team_code;
  }

  toAuth(success: string = ""){
    this.startAuth.emit(success)
  }

}
